import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_56cf2bb9 from 'nuxt_plugin_plugin_56cf2bb9' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_091d4a56 from 'nuxt_plugin_plugin_091d4a56' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_storagepluginc778e8e4_d1b46988 from 'nuxt_plugin_storagepluginc778e8e4_d1b46988' // Source: ./storage.plugin.c778e8e4.ts (mode: 'all')
import nuxt_plugin_storeindexcef87018_13d2ce42 from 'nuxt_plugin_storeindexcef87018_13d2ce42' // Source: ./store.index.cef87018.ts (mode: 'all')
import nuxt_plugin_landingPageTypesstore46825170_3ac8cd7c from 'nuxt_plugin_landingPageTypesstore46825170_3ac8cd7c' // Source: ./landingPageTypes.store.46825170.ts (mode: 'all')
import nuxt_plugin_storeindex2a6e6c1a_5ada757b from 'nuxt_plugin_storeindex2a6e6c1a_5ada757b' // Source: ./store.index.2a6e6c1a.ts (mode: 'all')
import nuxt_plugin_productsstore8f3a1c02_7f3d5894 from 'nuxt_plugin_productsstore8f3a1c02_7f3d5894' // Source: ./products.store.8f3a1c02.ts (mode: 'all')
import nuxt_plugin_storesstore6a850d1e_7d901c42 from 'nuxt_plugin_storesstore6a850d1e_7d901c42' // Source: ./stores.store.6a850d1e.ts (mode: 'all')
import nuxt_plugin_storeindex3d4f8530_27473d39 from 'nuxt_plugin_storeindex3d4f8530_27473d39' // Source: ./store.index.3d4f8530.ts (mode: 'all')
import nuxt_plugin_pluginutils_310d51cc from 'nuxt_plugin_pluginutils_310d51cc' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_4dfec7d2 from 'nuxt_plugin_pluginrouting_4dfec7d2' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_00289eb8 from 'nuxt_plugin_pluginmain_00289eb8' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_moment_02a5b729 from 'nuxt_plugin_moment_02a5b729' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_toast_bafa9e04 from 'nuxt_plugin_toast_bafa9e04' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_535b3762 from 'nuxt_plugin_axios_535b3762' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_bugsnag_2200fece from 'nuxt_plugin_bugsnag_2200fece' // Source: ../plugins/bugsnag.ts (mode: 'all')
import nuxt_plugin_directiveclient_007a8837 from 'nuxt_plugin_directiveclient_007a8837' // Source: ../plugins/directive.client.js (mode: 'client')
import nuxt_plugin_role_38e0118b from 'nuxt_plugin_role_38e0118b' // Source: ../plugins/role.js (mode: 'all')
import nuxt_plugin_permission_d4a2bbdc from 'nuxt_plugin_permission_d4a2bbdc' // Source: ../plugins/permission.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_codemirror_1be7a2d5 from 'nuxt_plugin_codemirror_1be7a2d5' // Source: ../plugins/codemirror.js (mode: 'all')
import nuxt_plugin_auth_2cc801fe from 'nuxt_plugin_auth_2cc801fe' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_authRedirect_ca5f40c6 from 'nuxt_plugin_authRedirect_ca5f40c6' // Source: ../plugins/authRedirect.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"LPM | %s","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon\u002Ffavicon.ico"},{"rel":"apple-touch-icon","type":"image\u002Fpng","sizes":"180x180","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon\u002Ffavicon-16x16.png"},{"rel":"mask-icon","href":"\u002Ffavicon\u002Fsafari-pinned-tab.svg"},{"rel":"manifest","href":"\u002Ffavicon\u002Fsite.webmanifest"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[{"hid":"cleverpush","src":"https:\u002F\u002Fstatic.cleverpush.com\u002Fchannel\u002Floader\u002FLjNXWjBHben8uWgHH.js","async":true,"defer":true,"body":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_56cf2bb9 === 'function') {
    await nuxt_plugin_plugin_56cf2bb9(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_091d4a56 === 'function') {
    await nuxt_plugin_plugin_091d4a56(app.context, inject)
  }

  if (typeof nuxt_plugin_storagepluginc778e8e4_d1b46988 === 'function') {
    await nuxt_plugin_storagepluginc778e8e4_d1b46988(app.context, inject)
  }

  if (typeof nuxt_plugin_storeindexcef87018_13d2ce42 === 'function') {
    await nuxt_plugin_storeindexcef87018_13d2ce42(app.context, inject)
  }

  if (typeof nuxt_plugin_landingPageTypesstore46825170_3ac8cd7c === 'function') {
    await nuxt_plugin_landingPageTypesstore46825170_3ac8cd7c(app.context, inject)
  }

  if (typeof nuxt_plugin_storeindex2a6e6c1a_5ada757b === 'function') {
    await nuxt_plugin_storeindex2a6e6c1a_5ada757b(app.context, inject)
  }

  if (typeof nuxt_plugin_productsstore8f3a1c02_7f3d5894 === 'function') {
    await nuxt_plugin_productsstore8f3a1c02_7f3d5894(app.context, inject)
  }

  if (typeof nuxt_plugin_storesstore6a850d1e_7d901c42 === 'function') {
    await nuxt_plugin_storesstore6a850d1e_7d901c42(app.context, inject)
  }

  if (typeof nuxt_plugin_storeindex3d4f8530_27473d39 === 'function') {
    await nuxt_plugin_storeindex3d4f8530_27473d39(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_310d51cc === 'function') {
    await nuxt_plugin_pluginutils_310d51cc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_4dfec7d2 === 'function') {
    await nuxt_plugin_pluginrouting_4dfec7d2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_00289eb8 === 'function') {
    await nuxt_plugin_pluginmain_00289eb8(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_02a5b729 === 'function') {
    await nuxt_plugin_moment_02a5b729(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_bafa9e04 === 'function') {
    await nuxt_plugin_toast_bafa9e04(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_535b3762 === 'function') {
    await nuxt_plugin_axios_535b3762(app.context, inject)
  }

  if (typeof nuxt_plugin_bugsnag_2200fece === 'function') {
    await nuxt_plugin_bugsnag_2200fece(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directiveclient_007a8837 === 'function') {
    await nuxt_plugin_directiveclient_007a8837(app.context, inject)
  }

  if (typeof nuxt_plugin_role_38e0118b === 'function') {
    await nuxt_plugin_role_38e0118b(app.context, inject)
  }

  if (typeof nuxt_plugin_permission_d4a2bbdc === 'function') {
    await nuxt_plugin_permission_d4a2bbdc(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_codemirror_1be7a2d5 === 'function') {
    await nuxt_plugin_codemirror_1be7a2d5(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_2cc801fe === 'function') {
    await nuxt_plugin_auth_2cc801fe(app.context, inject)
  }

  if (typeof nuxt_plugin_authRedirect_ca5f40c6 === 'function') {
    await nuxt_plugin_authRedirect_ca5f40c6(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
